import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Details, Term, Definition } from '../../common/Details'
import { InfoTooltip } from '../../common/Tooltip'
import { DetailsSection } from '../DetailsSection'
import { IconListGrid, ListItem } from '../../common/IconListGrid'
import withFreemium from '../../common/Freemium/WithFreemium'

export const MalwareCapabilities = ({ malware }) => {
  const [showCapabilities, setShowCapabilities] = useState(false)

  const {
    capabilities,
  } = malware || {}

  const CapabilitiesListGrid = withFreemium({ prop: 'list', layout: 'fullCenter' })(() => (
    <IconListGrid
      list={capabilities}
      showItems={showCapabilities}
      setShowItems={setShowCapabilities}
      displayLimit={9}
      cellWidths={['100%', '50%', '33.3333%']}
      renderItem={(item) => <ListItem>{item.name}</ListItem>}
    />
  ))

  return (
    <DetailsSection title="Capabilities">
      <Details>
        <Term>Capabilities <InfoTooltip tooltip="Observed capabilities of the selected code family." /></Term>
        <Definition>
          <CapabilitiesListGrid list={capabilities} />
        </Definition>
      </Details>
    </DetailsSection>
  )
}

MalwareCapabilities.propTypes = {
  malware: PropTypes.object
}
